
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M50 5C25.147 5 5 25.147 5 50c0 24.854 20.147 45 45 45 24.854 0 45-20.146 45-45C95 25.147 74.854 5 50 5zM24.446 67.475V44.307h10.342v23.168zm23.93 0H38.034V22.792h10.342zm13.59 0H51.625V33h10.341zm3.247 0V53h10.342v14.475zM24.446 48v-1.5h10.342V48zm23.93-7.5H38.034V42h10.342zm13.59-3H51.625V36h10.341zm3.247 17v-8.742h10.342V54.5z"}})])
      }
    
      }
    